export const priorityOption = [
    { label: "Low", value: "low" },
    { label: "Medium", value: "medium" },
    { label: "High", value: "high" },
]

export const RelatedToOption = [
    {
        label: "Other", value: "other", text: "OT", icon: "mdi mdi-dots-horizontal-circle-outline", color: "color-grey", id: 5, related: [
        ],
        role: 1
    },
    {
        label: "Sales", value: "sales", text: "SA", id: 3, icon: "mdi mdi-chart-bar", color: "text-success", related: [
            { label: "Lead", value: "lead" },
            { label: "Introducer", value: "introducer" },
            { label: "Proposal", value: "proposal" },
            { label: "Contract", value: "contract" },
            { label: "Marketing", value: "marketing" },
        ],
        role: 2
    },
    {
        label: "Work", value: "work", text: "WK", id: 4, icon: "dripicons-suitcase", color: "text-brown", related: [
            { label: "Resource Plan", value: "resource-plan" },
            { label: "Digital Marketing Project", value: "digital-project" },
            { label: "Development Project", value: "development-project" },
            { label: "Support", value: "support" },
            { label: "Icode", value: "Icode" },
        ],
        role: 4
    },
    {
        label: "Human Resource", value: "human-resource", text: "HR", id: 1, icon: "dripicons-user-group", color: "text-purple", related: [
            { label: "Staff", value: "staff" },
            { label: "Freelancer", value: "freelancer" },
            { label: "Payroll Management", value: "payroll-management" },
            { label: "List of Holidays", value: "list-of-holiday" },
            { label: "Festival", value: "festival" }
        ],
        role: 7
    },
    {
        label: "Finance", value: "finance", text: "FN", id: 2, icon: "fas fa-coins", color: "text-warning", related: [
            { label: "Expense", value: "expense" },
            { label: "Credit Card", value: "credit-card" },
            { label: "Invoice", value: "invoice" },
            { label: "GST", value: "gst" },
            { label: "TDS", value: "tds" },
        ],
        role: 8,
        role: 1
    },

]
export const GeneralTaskWork = [
    { label: "All", value: "all" },
    { label: "Not Started", value: "not-started" },
    { label: "In Progress", value: "in-progress" },
    { label: "Complete", value: "complete" },
]

export const TimeOption = [
    { label: "Nothing Selected", value: "Nothing Selected" },
    { label: "0.05", value: "0:05" },
    { label: "0.10", value: "0:10" },
    { label: "0.15", value: "0:15" },
    { label: "0.30", value: "0:30" },
    { label: "0.45", value: "0:45" },
    { label: "1.00", value: "1:00" },
    { label: "1.15", value: "1:15" },
    { label: "1.30", value: "1:30" },
    { label: "1.45", value: "1:45" },
    { label: "2.00", value: "2:00" },
    { label: "2.15", value: "2:15" },
    { label: "2.30", value: "2:30" },
    { label: "2.45", value: "2:45" },
    { label: "3.00", value: "3:00" },
    { label: "4.00", value: "4:00" },
    { label: "5.00", value: "5:00" },
    { label: "6.00", value: "6:00" },
    { label: "7.00", value: "7:00" },
    { label: "8.00", value: "8:00" },
]

export const colourStyles = {
    menuList: styles => ({
        ...styles,
        background: "white",
    }),
    menu: base => ({
        ...base,
        zIndex: 1200,
    }),
}

export const StaffOption = [

    {
        "value": 1,
        "label": "Admin"
    },
    {
        "value": 20,
        "label": "Janvi Bhagat"
    },
    {
        "value": 21,
        "label": "Zain Marchawali"
    },
    {
        "value": 44,
        "label": "Rahul Ovhal"
    },
    {
        "value": 46,
        "label": "zainual mukeshbhai marchawala"
    },
    {
        "value": 67,
        "label": "Mohit Kapadnis"
    },
    {
        "value": 68,
        "label": "All"
    },

]

export const ChanceOptions = [
    {
        value: "15",
        label: "15 Days"
    },
    {
        value: "30",
        label: "30 Days"
    },
    {
        value: "60",
        label: "60 Days"
    },
    {
        value: "90",
        label: "90 Days"
    }
]

export const DigitalServiceOptions = [
    {
        id: "1",
        text: "SEO",
        name: "Search Engine Optimization",
        icon: "bx bx-search-alt"
    },
    {
        id: "2",
        text: "SMM",
        name: "Social Media Marketing",
        icon: "bx bxs-megaphone"
    },
    {
        id: "3",
        text: "PPC",
        name: "Pay Per Click",
        icon: "mdi mdi-cursor-default-click"
    },
    {
        id: "4",
        text: "EM",
        name: "Email Marketing",
        icon: "mdi mdi-email-check"
    }
]

export const recurringTypeOptions = [
    {
        value: 'daily',
        label: 'Daily'
    },
    {
        value: 'weekly',
        label: 'Weekly'
    },
    {
        value: 'monthly',
        label: 'Monthly'
    },
]

export const daysOption = [
    {
        value: 'monday',
        label: 'Monday'
    },
    {
        value: 'tuesday',
        label: 'Tuesday'
    },
    {
        value: 'wednesday',
        label: 'Wednesday'
    },
    {
        value: 'thursday',
        label: 'Thursday'
    },
    {
        value: 'friday',
        label: 'Friday'
    },
]


export const ModuleOptions = [

    {
        "value": 'sales',
        "label": "Sales"
    },
    {
        "value": 'marketing',
        "label": "Marketing"
    },
    {
        "value": 'work',
        "label": "Work"
    },
    {
        "value": "human-resource",
        "label": "Human Resource"
    },
    {
        "value": 'audit-logs',
        "label": "Audit Logs"
    },
    {
        "value": 'finance',
        "label": "Finance"
    },
    {
        "value": 'report',
        "label": "Report"
    },


]

export const DigitalServiceOptionsDrop = [
    {
        value: "1",
        label: "SEO",
        name: "Search Engine Optimization",
        icon: "bx bx-search-alt",
        tabId: "3"
    },
    {
        value: "2",
        label: "SMM",
        name: "Social Media Marketing",
        icon: "bx bxs-megaphone",
        tabId: "7"
    },
    {
        value: "3",
        label: "PPC",
        name: "Pay Per Click",
        icon: "mdi mdi-cursor-default-click",
        tabId: "8"
    },
    {
        value: "4",
        label: "EM",
        name: "Email Marketing",
        icon: "mdi mdi-email-check",
        tabId: "9"
    }
]


export const ResourceType = [
    { label: "Fixed Rate", value: "1" },
    { label: "Project Hours", value: "2" },
    { label: "Dedicated Resource", value: "3" },
]
export const projectStatus = [
    { label: "Not Started", value: "0" },
    { label: "In Progress", value: "1" },
    { label: "On Hold", value: "2" },
    { label: "Cancelled", value: "3" },
    { label: "Finished", value: "4" },
]
export const OverviewOption = [
    {
        id: 1,
        label: "Today's",
        text: "Today's Task",
    },
    {
        id: 2,
        label: "Yesterday's",
        text: "Yesterday's Task",
    },
    {
        id: 3,
        label: "Pending ",
        text: "Pending Task",
    },
    {
        id: 4,
        label: "Audit",
        text: "Audit Task",
    },
    {
        id: 5,
        label: "SEO",
        text: "SEO Keyword Ranking",
    },
]

export const TypeDmOptions = [
    { label: "On Page", value: "on-page", service: "1" },
    { label: "Off Page", value: "off-page", service: "1" },
    { label: "Audit", value: "audit", service: "1" },
    { label: "Report", value: "report", service: "1" },
    { label: "Checking", value: "checking", service: "1" },
    { label: "Checking Report", value: "checking-report", service: "1" },
    { label: "Research", value: "research", service: "2" },
    { label: "Planning", value: "planning", service: "2" },
    { label: "Scheduling", value: "scheduling", service: "2" },
    { label: "Monitoring", value: "monitoring", service: "2" },
    { label: "Report", value: "Report", service: "2" },
    { label: "Checking Report", value: "checking-report", service: "2" },
    { label: "Planning", value: "planning", service: "3" },
    { label: "Campaign Management", value: "campaign-management", service: "3" },
    { label: "Monitoring", value: "monitoring", service: "3" },
    { label: "Report", value: "report", service: "3" },
    { label: "Checking Report", value: "checking-report", service: "3" },
    { label: "Research and Analysis", value: "Research and Analysis", service: "4" },
    { label: "Data Gathering", value: "data-gathering", service: "4" },
    { label: "Planning", value: "Planning", service: "4" },
    { label: "Designing & Scheduling", value: "designing-scheduling", service: "4" },
    { label: "Monitoring & Optimization", value: "monitoring-optimization", service: "4" },

]

export const FieldTypeOptions = [
    { label: "Input Field", value: "input", message: "In this field type, 3 field will be shown." },
    { label: "Text Area", value: "textarea", message: "In this field type, Text Area will be shown." },
    { label: "Multiple", value: "multiple", message: "In this field type, Multiple fields will be shown and you can add more." },
]

export const developmentProjectType = [
    { label: "Regular Project", value: "1" },
    { label: "Dedicated Resource", value: "2" },
    { label: "Maintenance Project", value: "3" },
]
export const developmentHours = [
    { label: "01.00", value: "1:00" },
    { label: "01.30", value: "1:30" },
    { label: "02.00", value: "2:00" },
    { label: "02.30", value: "2:30" },
    { label: "03.00", value: "3:00" },
    { label: "03.30", value: "3:30" },
    { label: "04.00", value: "4:00" },
    { label: "04.30", value: "4:30" },
    { label: "05.00", value: "5:00" },
    { label: "05.30", value: "5:30" },
    { label: "06.00", value: "6:00" },
    { label: "06.30", value: "6:30" },
    { label: "07.00", value: "7:00" },
    { label: "07.30", value: "7:30" },
    { label: "08.00", value: "8:00" },
    { label: "08.30", value: "8:30" },
    { label: "09.00", value: "9:00" },
    { label: "09.30", value: "9:30" },
    { label: "10.00", value: "10:00" },
    { label: "10.30", value: "10:30" },
    { label: "11.00", value: "11:00" },
    { label: "11.30", value: "11:30" },
    { label: "12.00", value: "12:00" },
]
export const milestoneType = [
    { label: "Milestone - Design", value: "1", type: "Design", text: "DS" },
    { label: "Milestone - Development", value: "2", type: "Development", text: "DE" },
    { label: "Milestone - Testing", value: "3", type: "Testing", text: "T" },
    { label: "Milestone - Deployment", value: "4", type: "Deployment", text: "DP" },
    { label: "Milestone - UAT", value: "5", type: "UAT", text: "U" },
]
export const allocationType = [
    {
        value: '1',
        label: 'Designing',
    },
    {
        value: '2',
        label: 'Development',
    },
    {
        value: '3',
        label: 'Testing',
    },
    {
        value: '4',
        label: 'Deployment',
    },
]
export const taskStatus = [
    {
        value: "1",
        label: "In Progress"
    },
    {
        value: "2",
        label: "Move to Test"
    },
    {
        value: "3",
        label: "Awaiting Feedback"
    },
    {
        value: "4",
        label: "Complete"
    },
]
export const developmentTaskStatus = [
    { label: "Pending", value: "0" },
    { label: "In Progress", value: "1" },
    { label: "Dev complete", value: "2" },
    { label: "Understanding", value: "3" },
    { label: "Awaiting Clients' Feedback", value: "5" },
]

export const resaonOtption = [
    {
        value: '1',
        label: "Missed Start – Apologies! I forgot to start the timer."
    },
    {
        value: '2',
        label: "Missed Stop – My mistake! I forgot to turn off the timer."
    },
    {
        value: '3',
        label: "Power Outage – Timer updates on hold until the lights return."
    },
    {
        value: '4',
        label: "Connectivity Issue – Network hiccup, timer update delayed."
    },
    {
        value: '5',
        label: "System Glitch – Technical issues preventing timer update."
    },
    {
        value: '6',
        label: "Project Adjustment"
    },
]

export const ticketStatus = [
    { label: "Not Answered", value: "0" },
    { label: "Open", value: "1" },
    { label: "In Progress", value: "2" },
    { label: "Answered", value: "3" },
    { label: "on Hold", value: "4" },
    { label: "Closed", value: "5" },
    { label: "Queries", value: "6" },
]

export const qaTaskList = [
    {
        value: "Create Test cases for Project",
        label: "Create Test cases for Project",
        type: 1
    },
    {
        value: "Test the project according to the test cases",
        label: "Test the project according to the test cases",
        type: 2
    },
]
export const testCaseStatus = [
    {
        value: "pass",
        label: "Pass"
    },
    {
        value: "fail",
        label: "Fail"
    }
]
export const issueType = [
    {
        value: "0",
        label: "Bug"
    },
    {
        value: "1",
        label: "Suggestion"
    },
]
export const preConditionSupport = [
    {
        value: "Network connection should be available",
        label: "Network connection should be available",
    },
    {
        value: "The website should be hosted on a staging server",
        label: "The website should be hosted on a staging server",
    },
    {
        value: "The website should be fully loaded without errors",
        label: "The website should be fully loaded without errors",
    },
]
export const locationOptions = [
    { label: "India", value: "1" },
    { label: "United kingdom", value: "2" },
    { label: "United States", value: "3" }
]
export const searchModules = [
    {
        value: "0",
        label: "All Module",
    },
    {
        value: "1",
        label: "Lead",
    },
    {
        value: "2",
        label: "Sales",
    },
    {
        value: "3",
        label: "Marketing",
    },
    {
        value: "4",
        label: "Work",
    },
    {
        value: "8",
        label: "Finance",
    },
]

export const serviceOption = [
    {
        label: "Website Designing and Development",
        value: "Website Designing and Development",
        sub: "development"
    },
    { label: "Website Redesigning", value: "Website Redesigning", sub: "development" },
    {
        label: "E-Commerce Website Design and Development",
        value: "E-Commerce Website Design and Development",
        sub: "development"
    },
    {
        label: "Mobile Application Development",
        value: "Mobile Application Development",
        sub: "development"
    },
    { label: "Customise CRM Development", value: "Customise CRM Development", sub: "development" },
    { label: "Customise ERP Development", value: "Customise ERP Development", sub: "development" },
    {
        label: "Custom Development of Website and CRM",
        value: "Custom Development of Website and CRM",
        sub: "development"
    },
    {
        label: "Custom Development of Website and CRM and Mobile Application",
        value: "Custom Development of Website and CRM and Mobile Application",
        sub: "development"
    },
    { label: "SEO", value: "SEO", sub: "digital" },
    { label: "Digital Marketing", value: "Digital Marketing", sub: "digital" },
    { label: "Dedicated Resource", value: "Dedicated Resource", sub: "digital" },
    { label: "Graphics Designing", value: "Graphics Designing", sub: "digital" },
    {
        label: "Maintenance Contract - Website",
        value: "Maintenance Contract - Website",
        sub: "maintenance"
    },
    {
        label: "Maintenance Contact - Custom System",
        value: "Maintenance Contact - Custom System",
        sub: "maintenance"
    },
    {
        label: "Maintenance Contract - Mobile Apps",
        value: "Maintenance Contract - Mobile Apps",
        sub: "maintenance"
    },
    {
        label: "Workforce & IT Infrastructure Management Services",
        value: "Workforce & IT Infrastructure Management Services",
        sub: "maintenance"
    },
]

export const timeSlots = [
    { id: 1, value: "12:00 AM-12:30 AM", label: "12:00 AM - 12:30 AM", from: "12:00 AM" },
    { id: 2, value: "12:30 AM-01:00 AM", label: "12:30 AM - 01:00 AM", from: "12:30 AM" },
    { id: 3, value: "01:00 AM-01:30 AM", label: "01:00 AM - 01:30 AM", from: "01:00 AM" },
    { id: 4, value: "01:30 AM-02:00 AM", label: "01:30 AM - 02:00 AM", from: "01:30 AM" },
    { id: 5, value: "02:00 AM-02:30 AM", label: "02:00 AM - 02:30 AM", from: "02:00 AM" },
    { id: 6, value: "02:30 AM-03:00 AM", label: "02:30 AM - 03:00 AM", from: "02:30 AM" },
    { id: 7, value: "03:00 AM-03:30 AM", label: "03:00 AM - 03:30 AM", from: "03:00 AM" },
    { id: 8, value: "03:30 AM-04:00 AM", label: "03:30 AM - 04:00 AM", from: "03:30 AM" },
    { id: 9, value: "04:00 AM-04:30 AM", label: "04:00 AM - 04:30 AM", from: "04:00 AM" },
    { id: 10, value: "04:30 AM-05:00 AM", label: "04:30 AM - 05:00 AM", from: "04:30 AM" },
    { id: 11, value: "05:00 AM-05:30 AM", label: "05:00 AM - 05:30 AM", from: "05:00 AM" },
    { id: 12, value: "05:30 AM-06:00 AM", label: "05:30 AM - 06:00 AM", from: "05:30 AM" },
    { id: 13, value: "06:00 AM-06:30 AM", label: "06:00 AM - 06:30 AM", from: "06:00 AM" },
    { id: 14, value: "06:30 AM-07:00 AM", label: "06:30 AM - 07:00 AM", from: "06:30 AM" },
    { id: 15, value: "07:00 AM-07:30 AM", label: "07:00 AM - 07:30 AM", from: "07:00 AM" },
    { id: 16, value: "07:30 AM-08:00 AM", label: "07:30 AM - 08:00 AM", from: "07:30 AM" },
    { id: 17, value: "08:00 AM-08:30 AM", label: "08:00 AM - 08:30 AM", from: "08:00 AM" },
    { id: 18, value: "08:30 AM-09:00 AM", label: "08:30 AM - 09:00 AM", from: "08:30 AM" },
    { id: 19, value: "09:00 AM-09:30 AM", label: "09:00 AM - 09:30 AM", from: "09:00 AM" },
    { id: 20, value: "09:30 AM-10:00 AM", label: "09:30 AM - 10:00 AM", from: "09:30 AM" },
    { id: 21, value: "10:00 AM-10:30 AM", label: "10:00 AM - 10:30 AM", from: "10:00 AM" },
    { id: 22, value: "10:30 AM-11:00 AM", label: "10:30 AM - 11:00 AM", from: "10:30 AM" },
    { id: 23, value: "11:00 AM-11:30 AM", label: "11:00 AM - 11:30 AM", from: "11:00 AM" },
    { id: 24, value: "11:30 AM-12:00 PM", label: "11:30 AM - 12:00 PM", from: "11:30 AM" },
    { id: 25, value: "12:00 PM-12:30 PM", label: "12:00 PM - 12:30 PM", from: "12:00 PM" },
    { id: 26, value: "12:30 PM-01:00 PM", label: "12:30 PM - 01:00 PM", from: "12:30 PM" },
    { id: 27, value: "01:00 PM-01:30 PM", label: "01:00 PM - 01:30 PM", from: "01:00 PM" },
    { id: 28, value: "01:30 PM-02:00 PM", label: "01:30 PM - 02:00 PM", from: "01:30 PM" },
    { id: 29, value: "02:00 PM-02:30 PM", label: "02:00 PM - 02:30 PM", from: "02:00 PM" },
    { id: 30, value: "02:30 PM-03:00 PM", label: "02:30 PM - 03:00 PM", from: "02:30 PM" },
    { id: 31, value: "03:00 PM-03:30 PM", label: "03:00 PM - 03:30 PM", from: "03:00 PM" },
    { id: 32, value: "03:30 PM-04:00 PM", label: "03:30 PM - 04:00 PM", from: "03:30 PM" },
    { id: 33, value: "04:00 PM-04:30 PM", label: "04:00 PM - 04:30 PM", from: "04:00 PM" },
    { id: 34, value: "04:30 PM-05:00 PM", label: "04:30 PM - 05:00 PM", from: "04:30 PM" },
    { id: 35, value: "05:00 PM-05:30 PM", label: "05:00 PM - 05:30 PM", from: "05:00 PM" },
    { id: 36, value: "05:30 PM-06:00 PM", label: "05:30 PM - 06:00 PM", from: "05:30 PM" },
    { id: 37, value: "06:00 PM-06:30 PM", label: "06:00 PM - 06:30 PM", from: "06:00 PM" },
    { id: 38, value: "06:30 PM-07:00 PM", label: "06:30 PM - 07:00 PM", from: "06:30 PM" },
    { id: 39, value: "07:00 PM-07:30 PM", label: "07:00 PM - 07:30 PM", from: "07:00 PM" },
    { id: 40, value: "07:30 PM-08:00 PM", label: "07:30 PM - 08:00 PM", from: "07:30 PM" },
    { id: 41, value: "08:00 PM-08:30 PM", label: "08:00 PM - 08:30 PM", from: "08:00 PM" },
    { id: 42, value: "08:30 PM-09:00 PM", label: "08:30 PM - 09:00 PM", from: "08:30 PM" },
    { id: 43, value: "09:00 PM-09:30 PM", label: "09:00 PM - 09:30 PM", from: "09:00 PM" },
    { id: 44, value: "09:30 PM-10:00 PM", label: "09:30 PM - 10:00 PM", from: "09:30 PM" },
    { id: 45, value: "10:00 PM-10:30 PM", label: "10:00 PM - 10:30 PM", from: "10:00 PM" },
    { id: 46, value: "10:30 PM-11:00 PM", label: "10:30 PM - 11:00 PM", from: "10:30 PM" },
    { id: 47, value: "11:00 PM-11:30 PM", label: "11:00 PM - 11:30 PM", from: "11:00 PM" },
    { id: 48, value: "11:30 PM-12:00 AM", label: "11:30 PM - 12:00 AM", from: "11:30 PM" },
]
export const aryIanaTimeZones = [
    "Europe/Andorra",
    "Asia/Dubai",
    "Asia/Kabul",
    "Europe/Tirane",
    "Asia/Yerevan",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Mawson",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Cordoba",
    "America/Argentina/Salta",
    "America/Argentina/Jujuy",
    "America/Argentina/Tucuman",
    "America/Argentina/Catamarca",
    "America/Argentina/La_Rioja",
    "America/Argentina/San_Juan",
    "America/Argentina/Mendoza",
    "America/Argentina/San_Luis",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Ushuaia",
    "Pacific/Pago_Pago",
    "Europe/Vienna",
    "Australia/Lord_Howe",
    "Antarctica/Macquarie",
    "Australia/Hobart",
    "Australia/Currie",
    "Australia/Melbourne",
    "Australia/Sydney",
    "Australia/Broken_Hill",
    "Australia/Brisbane",
    "Australia/Lindeman",
    "Australia/Adelaide",
    "Australia/Darwin",
    "Australia/Perth",
    "Australia/Eucla",
    "Asia/Baku",
    "America/Barbados",
    "Asia/Dhaka",
    "Europe/Brussels",
    "Europe/Sofia",
    "Atlantic/Bermuda",
    "Asia/Brunei",
    "America/La_Paz",
    "America/Noronha",
    "America/Belem",
    "America/Fortaleza",
    "America/Recife",
    "America/Araguaina",
    "America/Maceio",
    "America/Bahia",
    "America/Sao_Paulo",
    "America/Campo_Grande",
    "America/Cuiaba",
    "America/Santarem",
    "America/Porto_Velho",
    "America/Boa_Vista",
    "America/Manaus",
    "America/Eirunepe",
    "America/Rio_Branco",
    "America/Nassau",
    "Asia/Thimphu",
    "Europe/Minsk",
    "America/Belize",
    "America/St_Johns",
    "America/Halifax",
    "America/Glace_Bay",
    "America/Moncton",
    "America/Goose_Bay",
    "America/Blanc-Sablon",
    "America/Toronto",
    "America/Nipigon",
    "America/Thunder_Bay",
    "America/Iqaluit",
    "America/Pangnirtung",
    "America/Atikokan",
    "America/Winnipeg",
    "America/Rainy_River",
    "America/Resolute",
    "America/Rankin_Inlet",
    "America/Regina",
    "America/Swift_Current",
    "America/Edmonton",
    "America/Cambridge_Bay",
    "America/Yellowknife",
    "America/Inuvik",
    "America/Creston",
    "America/Dawson_Creek",
    "America/Fort_Nelson",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Dawson",
    "Indian/Cocos",
    "Europe/Zurich",
    "Africa/Abidjan",
    "Pacific/Rarotonga",
    "America/Santiago",
    "America/Punta_Arenas",
    "Pacific/Easter",
    "Asia/Shanghai",
    "Asia/Urumqi",
    "America/Bogota",
    "America/Costa_Rica",
    "America/Havana",
    "Atlantic/Cape_Verde",
    "America/Curacao",
    "Indian/Christmas",
    "Asia/Nicosia",
    "Asia/Famagusta",
    "Europe/Prague",
    "Europe/Berlin",
    "Europe/Copenhagen",
    "America/Santo_Domingo",
    "Africa/Algiers",
    "America/Guayaquil",
    "Pacific/Galapagos",
    "Europe/Tallinn",
    "Africa/Cairo",
    "Africa/El_Aaiun",
    "Europe/Madrid",
    "Africa/Ceuta",
    "Atlantic/Canary",
    "Europe/Helsinki",
    "Pacific/Fiji",
    "Atlantic/Stanley",
    "Pacific/Chuuk",
    "Pacific/Pohnpei",
    "Pacific/Kosrae",
    "Atlantic/Faroe",
    "Europe/Paris",
    "Europe/London",
    "Asia/Tbilisi",
    "America/Cayenne",
    "Africa/Accra",
    "Europe/Gibraltar",
    "America/Godthab",
    "America/Danmarkshavn",
    "America/Scoresbysund",
    "America/Thule",
    "Europe/Athens",
    "Atlantic/South_Georgia",
    "America/Guatemala",
    "Pacific/Guam",
    "Africa/Bissau",
    "America/Guyana",
    "Asia/Hong_Kong",
    "America/Tegucigalpa",
    "America/Port-au-Prince",
    "Europe/Budapest",
    "Asia/Jakarta",
    "Asia/Pontianak",
    "Asia/Makassar",
    "Asia/Jayapura",
    "Europe/Dublin",
    "Asia/Jerusalem",
    "Asia/Kolkata",
    "Indian/Chagos",
    "Asia/Baghdad",
    "Asia/Tehran",
    "Atlantic/Reykjavik",
    "Europe/Rome",
    "America/Jamaica",
    "Asia/Amman",
    "Asia/Tokyo",
    "Africa/Nairobi",
    "Asia/Bishkek",
    "Pacific/Tarawa",
    "Pacific/Enderbury",
    "Pacific/Kiritimati",
    "Asia/Pyongyang",
    "Asia/Seoul",
    "Asia/Almaty",
    "Asia/Qyzylorda",
    "Asia/Qostanay",
    "Asia/Aqtobe",
    "Asia/Aqtau",
    "Asia/Atyrau",
    "Asia/Oral",
    "Asia/Beirut",
    "Asia/Colombo",
    "Africa/Monrovia",
    "Europe/Vilnius",
    "Europe/Luxembourg",
    "Europe/Riga",
    "Africa/Tripoli",
    "Africa/Casablanca",
    "Europe/Monaco",
    "Europe/Chisinau",
    "Pacific/Majuro",
    "Pacific/Kwajalein",
    "Asia/Yangon",
    "Asia/Ulaanbaatar",
    "Asia/Hovd",
    "Asia/Choibalsan",
    "Asia/Macau",
    "America/Martinique",
    "Europe/Malta",
    "Indian/Mauritius",
    "Indian/Maldives",
    "America/Mexico_City",
    "America/Cancun",
    "America/Merida",
    "America/Monterrey",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Chihuahua",
    "America/Ojinaga",
    "America/Hermosillo",
    "America/Tijuana",
    "America/Bahia_Banderas",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Africa/Maputo",
    "Africa/Windhoek",
    "Pacific/Noumea",
    "Pacific/Norfolk",
    "Africa/Lagos",
    "America/Managua",
    "Europe/Amsterdam",
    "Europe/Oslo",
    "Asia/Kathmandu",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Auckland",
    "Pacific/Chatham",
    "America/Panama",
    "America/Lima",
    "Pacific/Tahiti",
    "Pacific/Marquesas",
    "Pacific/Gambier",
    "Pacific/Port_Moresby",
    "Pacific/Bougainville",
    "Asia/Manila",
    "Asia/Karachi",
    "Europe/Warsaw",
    "America/Miquelon",
    "Pacific/Pitcairn",
    "America/Puerto_Rico",
    "Asia/Gaza",
    "Asia/Hebron",
    "Europe/Lisbon",
    "Atlantic/Madeira",
    "Atlantic/Azores",
    "Pacific/Palau",
    "America/Asuncion",
    "Asia/Qatar",
    "Indian/Reunion",
    "Europe/Bucharest",
    "Europe/Belgrade",
    "Europe/Kaliningrad",
    "Europe/Moscow",
    "Europe/Simferopol",
    "Europe/Kirov",
    "Europe/Astrakhan",
    "Europe/Volgograd",
    "Europe/Saratov",
    "Europe/Ulyanovsk",
    "Europe/Samara",
    "Asia/Yekaterinburg",
    "Asia/Omsk",
    "Asia/Novosibirsk",
    "Asia/Barnaul",
    "Asia/Tomsk",
    "Asia/Novokuznetsk",
    "Asia/Krasnoyarsk",
    "Asia/Irkutsk",
    "Asia/Chita",
    "Asia/Yakutsk",
    "Asia/Khandyga",
    "Asia/Vladivostok",
    "Asia/Ust-Nera",
    "Asia/Magadan",
    "Asia/Sakhalin",
    "Asia/Srednekolymsk",
    "Asia/Kamchatka",
    "Asia/Anadyr",
    "Asia/Riyadh",
    "Pacific/Guadalcanal",
    "Indian/Mahe",
    "Africa/Khartoum",
    "Europe/Stockholm",
    "Asia/Singapore",
    "America/Paramaribo",
    "Africa/Juba",
    "Africa/Sao_Tome",
    "America/El_Salvador",
    "Asia/Damascus",
    "America/Grand_Turk",
    "Africa/Ndjamena",
    "Indian/Kerguelen",
    "Asia/Bangkok",
    "Asia/Dushanbe",
    "Pacific/Fakaofo",
    "Asia/Dili",
    "Asia/Ashgabat",
    "Africa/Tunis",
    "Pacific/Tongatapu",
    "Europe/Istanbul",
    "America/Port_of_Spain",
    "Pacific/Funafuti",
    "Asia/Taipei",
    "Europe/Kiev",
    "Europe/Uzhgorod",
    "Europe/Zaporozhye",
    "Pacific/Wake",
    "America/New_York",
    "America/Detroit",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Indiana/Indianapolis",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Vevay",
    "America/Chicago",
    "America/Indiana/Tell_City",
    "America/Indiana/Knox",
    "America/Menominee",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/North_Dakota/Beulah",
    "America/Denver",
    "America/Boise",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Juneau",
    "America/Sitka",
    "America/Metlakatla",
    "America/Yakutat",
    "America/Nome",
    "America/Adak",
    "Pacific/Honolulu",
    "America/Montevideo",
    "Asia/Samarkand",
    "Asia/Tashkent",
    "America/Caracas",
    "Asia/Ho_Chi_Minh",
    "Pacific/Efate",
    "Pacific/Wallis",
    "Pacific/Apia",
    "Africa/Johannesburg",
]

export const workingtimeSlots = [
    { id: 15, value: "07:00 AM-07:30 AM", label: "07:00 AM - 07:30 AM", from: "07:00 AM" },
    { id: 16, value: "07:30 AM-08:00 AM", label: "07:30 AM - 08:00 AM", from: "07:30 AM" },
    { id: 17, value: "08:00 AM-08:30 AM", label: "08:00 AM - 08:30 AM", from: "08:00 AM" },
    { id: 18, value: "08:30 AM-09:00 AM", label: "08:30 AM - 09:00 AM", from: "08:30 AM" },
    { id: 19, value: "09:00 AM-09:30 AM", label: "09:00 AM - 09:30 AM", from: "09:00 AM" },
    { id: 20, value: "09:30 AM-10:00 AM", label: "09:30 AM - 10:00 AM", from: "09:30 AM" },
    { id: 21, value: "10:00 AM-10:30 AM", label: "10:00 AM - 10:30 AM", from: "10:00 AM" },
    { id: 22, value: "10:30 AM-11:00 AM", label: "10:30 AM - 11:00 AM", from: "10:30 AM" },
    { id: 23, value: "11:00 AM-11:30 AM", label: "11:00 AM - 11:30 AM", from: "11:00 AM" },
    { id: 24, value: "11:30 AM-12:00 PM", label: "11:30 AM - 12:00 PM", from: "11:30 AM" },
    { id: 25, value: "12:00 PM-12:30 PM", label: "12:00 PM - 12:30 PM", from: "12:00 PM" },
    { id: 26, value: "12:30 PM-01:00 PM", label: "12:30 PM - 01:00 PM", from: "12:30 PM" },
    { id: 27, value: "01:00 PM-01:30 PM", label: "01:00 PM - 01:30 PM", from: "01:00 PM" },
    { id: 28, value: "01:30 PM-02:00 PM", label: "01:30 PM - 02:00 PM", from: "01:30 PM" },
    { id: 29, value: "02:00 PM-02:30 PM", label: "02:00 PM - 02:30 PM", from: "02:00 PM" },
    { id: 30, value: "02:30 PM-03:00 PM", label: "02:30 PM - 03:00 PM", from: "02:30 PM" },
    { id: 31, value: "03:00 PM-03:30 PM", label: "03:00 PM - 03:30 PM", from: "03:00 PM" },
    { id: 32, value: "03:30 PM-04:00 PM", label: "03:30 PM - 04:00 PM", from: "03:30 PM" },
    { id: 33, value: "04:00 PM-04:30 PM", label: "04:00 PM - 04:30 PM", from: "04:00 PM" },
    { id: 34, value: "04:30 PM-05:00 PM", label: "04:30 PM - 05:00 PM", from: "04:30 PM" },
    { id: 35, value: "05:00 PM-05:30 PM", label: "05:00 PM - 05:30 PM", from: "05:00 PM" },
    { id: 36, value: "05:30 PM-06:00 PM", label: "05:30 PM - 06:00 PM", from: "05:30 PM" },
    { id: 37, value: "06:00 PM-06:30 PM", label: "06:00 PM - 06:30 PM", from: "06:00 PM" },
    { id: 38, value: "06:30 PM-07:00 PM", label: "06:30 PM - 07:00 PM", from: "06:30 PM" },
]

export const paymentSchemeOptions = [
    { value: "1", label: "Monthly" },
    { value: "2", label: "Weekly" },
    { value: "3", label: "Half Monthly" },
]
export const renewOptions = [
    { value: 1, label: "1 Month" },
    { value: 3, label: "3 Months" },
    { value: 6, label: "6 Months" },
    { value: 12, label: "1 Year" },
]

export const workOptionService = [
    {
        value: 'development',
        label: 'Development'
    },
    {
        value: 'digital',
        label: 'Digital Marketing'
    },
    {
        value: 'maintenance',
        label: 'Maintenance'
    },
]

export const DashboardElement = [
    {
        label: "Profile",
        value: 1
    },
    {
        label: "Favorite Leads",
        value: 2
    },
    {
        label: "Lead Potentials",
        value: 8
    },
    {
        label: "Absentees",
        value: 3
    },
    {
        label: "Document Approval",
        value: 9
    },
    {
        label: "Swipe & Issues",
        value: 6
    },
    {
        label: "My Activity",
        value: 10
    },
    {
        label: "Teams Activity",
        value: 5
    },
    {
        label: "Project Overview",
        value: 7
    },
    {
        label: "Leaves Approval",
        value: 11
    },
    {
        label: "Work Duration",
        value: 12
    },
    {
        label: "Git Pushed Pending",
        value: 13
    },
    {
        label: "Clear Logins",
        value: 14
    },
    {
        label: "Flaws & Gaps",
        value: 15
    },
    {
        label: "Notifications",
        value: 16
    },
    {
        label: "Flaws & Gap List",
        value: 17
    },
    {
        label: "Overdraft Report",
        value: 18
    },
    {
        label: "Timer Approval",
        value: 19
    },
    {
        label: "Project Coins",
        value: 20
    },
    {
        label: "QA Task Allotment",
        value: 21
    },
    {
        label: "Queries Tickets",
        value: 22
    },
    {
        label: "Earth Zai Tickets",
        value: 23
    },
    {
        label: "Estimated Salary",
        value: 24
    },
    {
        label: "Pending Invoice",
        value: 25
    },
    {
        label: "Past Six Month Leaves",
        value: 26
    },
    {
        label: "Working Hours",
        value: 27
    },
    {
        label: "Version Control",
        value: 28
    },
    {
        label: "Lead Sales Report - UK",
        value: 30
    },
    {
        label: "Code Review Queries",
        value: 32
    },
    {
        label: "Current Project Timer",
        value: 33
    },
    {
        label: "All Projects",
        value: 34
    },
    {
        label: "Work Load Report",
        value: 35
    },
    {
        label: "Overall Today's Work",
        value: 36
    },
    {
        label: "Introducer Commission",
        value: 38
    },
    {
        label: "Pending Leaves",
        value: 39
    },
    {
        label: "Punch Approval",
        value: 40
    },
    {
        label: "My Punch Logs",
        value: 41
    },
    {
        label: "Developer's Today's Task",
        value: 42
    },
    {
        label: "Leave Report",
        value: 43
    },
    {
        label: "SEO Report Approval",
        value: 44
    },
    {
        label: "Hosting",
        value: 45
    },
    {
        label: "LinkedIn Report",
        value: 46
    },
    {
        label: "Projection Current Finance",
        value: 47
    },
    {
        label: "RFP Approvals",
        value: 50
    },
    {
        label: "Sales Report India",
        value: 51
    },
]
export const TenderStatus = [
    { value: "accepted", label: "Accepted " },
    { value: 'rejected', label: "Rejected " },
    { value: "optout", label: "Optout " },
    { value: "submited", label: "Submited" },
    { value: "working on question", label: "Working on Question" },
    { value: "rejester interest", label: "Rejester Interest" },
    { value: "others", label: "Others" },
]
export const BiddingStatus = [
    { value: "Job Identified", label: "Job Identified" },
    { value: "Proposal In Progress", label: "Proposal In Progress" },
    { value: "Proposal Sent", label: "Proposal Sent" },
    { value: "Proposal Viewed", label: "Proposal Viewed" },
    { value: "Interview Scheduled", label: "Interview Scheduled" },
    { value: "Interview Completed", label: "Interview Completed" },
    { value: "Hired", label: "Hired" },
    { value: "Not Selected", label: "Not Selected" },
    { value: "Contract Completed", label: "Contract Completed" }
];

export const invoice_type = [
    { label: "Project / Resource", value: "Project / Resource" },
    { label: "Hosting", value: "Hosting" },
    { label: "Mainetance", value: "Mainetance" },
]

export const termsOption = [
    { label: "Due on Receipt", value: "Due on Receipt", day: '0' },
    { label: "Due in 15 days", value: "Due in 15 days", day: '15' },
    { label: "Due in 30 days", value: "Due in 30 days", day: '30' },
    { label: "Due in 60 days", value: "Due in 60 days", day: '60' },
]
export const hnsOptions = [
    { value: "998313", label: "998313 - Support & consulting service" },
    { value: "998314", label: "998314 - Design & Development Service" },
    { value: "998315", label: "998315 - Hosting Services" },
    { value: "8543", label: "8543 - Hardware" },
]
export const discountTypeOption = [
    { label: "Percentage %", value: "Percentage" },
    { label: "Fixed", value: "Fixed" },
]
export const customerType = [
    {
        value: 1,
        label: "Permanant Customer",
    },
    {
        value: 2,
        label: "Temporary Customer",
    },
]

export const otherProjectsList = [
    {
        label: "Human Resource",
        value: 1,
        type: 2,
    },
    {
        label: "Finance",
        value: 2,
        type: 2,
    },
    {
        label: "Sales & Marketing",
        value: 3,
        type: 2,
    },
    {
        label: "Others",
        value: 4,
        type: 2,
    },
]